import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { ZigZagHeadingAndAltCtaInitVariables } from './zigzag-heading-and-alt-cta.interface';

export interface X3ExperiencesModel extends BaseModel {
  variables?: { [key: string]: string } | X3ExperiencesVariables;
}

export interface X3ExperiencesVariables {
  X3Exp1Image: string;
  X3Exp2Image: string;
  X3Exp3Image: string;
  X3Exp1ImageHref: string;
  X3Exp2ImageHref: string;
  X3Exp3ImageHref: string;
  X3Exp1ImageAlt: string;
  X3Exp2ImageAlt: string;
  X3Exp3ImageAlt: string;
  X3Exp1Heading: string;
  X3Exp2Heading: string;
  X3Exp3Heading: string;
  X3Exp1CtaLink: string;
  X3Exp2CtaLink: string;
  X3Exp3CtaLink: string;
  X3Exp1CtaText: string;
  X3Exp2CtaText: string;
  X3Exp3CtaText: string;
  X3Exp1ImageHrefSegmentRegex: string;
  X3Exp2ImageHrefSegmentRegex: string;
  X3Exp3ImageHrefSegmentRegex: string;
  X3Exp1CtaLinkSegmentRegex: string;
  X3Exp2CtaLinkSegmentRegex: string;
  X3Exp3CtaLinkSegmentRegex: string;
}

export class X3ExperiencesInitVariables implements X3ExperiencesVariables {
  X3Exp1Image = '';
  X3Exp2Image = '';
  X3Exp3Image = '';
  X3Exp1ImageHref = '';
  X3Exp2ImageHref = '';
  X3Exp3ImageHref = '';
  X3Exp1ImageAlt = '';
  X3Exp2ImageAlt = '';
  X3Exp3ImageAlt = '';
  X3Exp1Heading = '';
  X3Exp2Heading = '';
  X3Exp3Heading = '';
  X3Exp1CtaLink = '';
  X3Exp2CtaLink = '';
  X3Exp3CtaLink = '';
  X3Exp1CtaText = '';
  X3Exp2CtaText = '';
  X3Exp3CtaText = '';
  X3Exp1ImageHrefSegmentRegex = '';
  X3Exp2ImageHrefSegmentRegex = '';
  X3Exp3ImageHrefSegmentRegex = '';
  X3Exp1CtaLinkSegmentRegex = '';
  X3Exp2CtaLinkSegmentRegex = '';
  X3Exp3CtaLinkSegmentRegex = '';
}

export class X3ExperiencesInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new X3ExperiencesInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
